module.exports = __webpack_public_path__ + "assets/img/img150.6546c5fe.png";